module.exports = __webpack_public_path__ + "img/banner_home.cfcd6bdf.png";